import { Button, Grid, InputLabel, Switch, TextField } from '@material-ui/core';
import Drawer from '@material-ui/core/Drawer/Drawer';
import ProductQuickView from 'components/Shared/ProductQuickView';
import Snackbar from 'components/Shared/Snackbar';
import { SvgIcon } from 'components/Shared/SvgIcon';
import { IProductNew } from 'interfaces/product';
import React, { useEffect, useState } from 'react';
import { combineLatest } from 'rxjs';
import { configService } from 'services/configService';

import rxjsOperators from 'rxjs-operators';
import { analyticsG4, enFeatures } from 'services/AnalyticsG4';
import { productNewService } from 'services/productNewService';
import SelectProduct from './SelectProduct';
import { useStyles } from './styles';

export default function BackRedirect() {
  const classes = useStyles();

  const [show, setShow] = useState<boolean>(false);
  const [products, setProducts] = useState<IProductNew[] | null>(null);
  const [productSelected, setProductSelected] = useState<IProductNew | null>(null);
  const [productDefaultConfig, setProductDefaultConfig] = useState<IProductNew['config'] | null>(null);

  const handleClose = () => {
    setProducts(null);
    setProductDefaultConfig(null);
    setProductSelected(null);
    configService.hideDrawer();
  };

  const handleUpdateBackRedirectActive = () => {
    setProductDefaultConfig(({ backRedirect, ...othersConfig }) => ({
      ...othersConfig,
      backRedirect: { ...backRedirect, active: !backRedirect?.active }
    }));
  };

  const handleUpdateBackRedirectId = (id: string) => {
    setProductDefaultConfig(({ backRedirect, ...othersConfig }) => ({
      ...othersConfig,
      backRedirect: { ...backRedirect, id }
    }));
  };

  const handleOnClickSave = async () => {
    if (!productDefaultConfig.backRedirect?.id) {
      return Snackbar.error('Por favor, selecione um produto!');
    }

    const principalId = productSelected?.id;
    const backRedirectId = productDefaultConfig.backRedirect.id;

    const updatedConfig: IProductNew['config'] = {
      ...productDefaultConfig,
      backRedirect: {
        active: !!productDefaultConfig?.backRedirect?.active,
        id: backRedirectId,
        url: `${backRedirectId}?utm_source=backredirect-${principalId}`
      }
    };

    configService
      .saveConfig(updatedConfig)
      .pipe(rxjsOperators.loader())
      .subscribe(() => {
        analyticsG4.sendSuccess(enFeatures.BACK_REDIRECT);
        Snackbar.show('Configuração salva!');
        productNewService.setSelectedProduct({ ...productSelected, config: updatedConfig });
        productNewService.refreshProducts();
      });

    handleClose();
  };

  useEffect(() => {
    combineLatest([
      productNewService.getProductsWithoutSelected(),
      configService.getSelectedProduct(),
      configService.getProductConfig()
    ]).subscribe(([products, productSelected, productDefaultConfig]) => {
      setProducts(products);
      setProductSelected(productSelected);
      setProductDefaultConfig(productDefaultConfig);

      analyticsG4.sendPageView({ feature: enFeatures.BACK_REDIRECT });
    });

    configService
      .getVisibility()
      .pipe(rxjsOperators.map(drawer => drawer === 'backRedirect'))
      .subscribe(show => setShow(show));
  }, []);

  if (!show || (!productSelected && !productDefaultConfig)) {
    return null;
  }

  return (
    <Drawer
      anchor="right"
      open={!!productSelected}
      PaperProps={{ classes: { root: classes.drawerPaper } }}
      transitionDuration={{ enter: 300, exit: 500 }}
      ModalProps={{
        disableBackdropClick: true,
        onBackdropClick: handleClose
      }}
    >
      <div className={classes.drawerOptions}>
        <div className={classes.titleClose}>
          <h2 className={classes.h2}>Back Redirect</h2>
          <span className={classes.closeButton} onClick={handleClose}>
            <SvgIcon name={'closeIcon'} />
          </span>
        </div>

        <ProductQuickView />

        <Grid container spacing={16} alignItems="center" justify="space-between">
          <Grid item xs={12}>
            <InputLabel className={classes.label}>Desativar/Ativar</InputLabel>
            <Switch
              disableRipple
              onChange={handleUpdateBackRedirectActive}
              value={productDefaultConfig?.backRedirect?.active}
              checked={productDefaultConfig?.backRedirect?.active}
            />
          </Grid>

          <Grid item xs={12}>
            <SelectProduct
              data={products}
              onSelectedId={handleUpdateBackRedirectId}
              defaultBackRedirectId={productDefaultConfig?.backRedirect?.id}
            />
          </Grid>

          <Grid item xs={12}>
            <InputLabel className={classes.label}>Parâmetros Adicionais</InputLabel>
            <TextField
              disabled
              className={classes.disabledField}
              value={`utm_source=backredirect-${productSelected?.id}`}
            />

            <span className={classes.observationSpan}>
              O UTM_SOURCE não é editável e ele será substituído pelo redirecionamento do checkout para que possa
              gerenciar as compras efetuadas através do Back Redirect.
            </span>
          </Grid>
          <Grid item xs={12} className={classes.containerButton}>
            <Button onClick={handleOnClickSave} className={classes.button}>
              Salvar
            </Button>
          </Grid>
        </Grid>
      </div>
    </Drawer>
  );
}
